import * as React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import * as Edge from '../../../../core';
import Table from '../../../../components/table';
import { withLoadDataDefaultConfig } from '../../../../components/loadData';
import errorLoadingWrapperHOC from '../../../../components/errorLoadingWrapper/errorLoadingWrapperHOC';
import { StatsService } from '../../../../services/statsService';
import { AppState } from '../../../../store';

interface GuardVisionStatsTableProps {
	stats?: Edge.Models.GuardVisionStat[];
	team?: Edge.Models.Team;
}

const availableSorts: { [x: string]: (item: Edge.Models.GuardVisionStat) => any } = {
	name: (item) => item.userDisplayName,
	date: (item) => item.createdDateUtc,
	passFail: (item) => item.passFail,
};

const availableSearches: ((item: Edge.Models.GuardVisionStat) => string | undefined)[] = [
	(item) => item.userDisplayName,
];

const GuardVisionStatsTable: React.FC<GuardVisionStatsTableProps> = ({ stats, team }) => {
	const pageSize = 20;

	return (
		<div className="guard_vision_stats_table">
			<Table
				items={stats || []}
				renderHeader={() => <></>}
				searchPlaceholderText={`Search by Name`}
				availableSorts={availableSorts}
				availableSearches={availableSearches}
				initialSort={['!date']}
				renderTableHeader={(classNames, toggleSort) => {
					return (
						<tr>
							<th className={classNames('name')} onClick={toggleSort.bind(null, 'name')}>
								Name
							</th>
							<th className={classNames('date')} onClick={toggleSort.bind(null, 'date')}>
								Date
							</th>
							<th className={classNames('passFail')} onClick={toggleSort.bind(null, 'passFail')}>
								Pass/Fail
							</th>
						</tr>
					);
				}}
				renderTableItem={(i) => {
					return (
						<tr>
							<td>{i.userDisplayName}</td>
							<td>{i.createdDateUtc && moment(i.createdDateUtc).format(Edge.Constants.DATE_FORMAT)}</td>
							<td>{i.passFail}</td>
						</tr>
					);
				}}
				renderNoItems={() => (
					<tr>
						<td colSpan={3}>No stats to show.</td>
					</tr>
				)}
				pagingMode="numbers"
				pageSize={pageSize}
			/>
		</div>
	);
};

function mapStateToProps(state: AppState) {
	const { currentTeam } = state.teamState;

	return {
		team: currentTeam,
	};
}

export default connect(mapStateToProps)(
	withLoadDataDefaultConfig(
		errorLoadingWrapperHOC(GuardVisionStatsTable, (props: GuardVisionStatsTableProps) => !!props.team),
		(props: GuardVisionStatsTableProps) => {
			return {
				team: props.team,
			};
		},
		async (props) => {
			if (!props.team) {
				return;
			}
			const stats = await StatsService.getGuardVisionStats(props.team.id);
			return {
				team: props.team,
				stats,
			};
		}
	)
);
